export default {
  // 可能是通用的
  New_Chat: 'New Chat',
  Tools: 'Tools',
  AI_Presentation: 'AI Presentation',
  AI_ChatPDF: 'AI ChatPDF',
  AI_Image: 'AI Image',
  AI_Translation: 'AI Translation',
  Text_Optimezation: 'Text Optimezation',
  My_Vip: 'My Vip',
  Assets: 'Assets',
  Chat_History: 'Chat History',
  Pricing: 'Pricing'
  // 独有
  // aside: {
  //   video_image: 'AI Video & lmage'
  // }
}
